import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Form, Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../../components/DataNotFound';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import DatePickerLayout from '../../../../../components/elements/DatePicker';
import ImageViewModal from '../../../../../components/elements/ImageViewModal';
import SearchFilters from '../../../../../components/elements/SearchFilter';
import { deleteAsync, getAsync, postAsync, putAsync } from '../../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../../components/helper/downloadCSVHelper';
import { PageHitCountApi } from '../../../../../shared/Helper';
import InfograpicModal from './InfograpicModal';
import { useLocation } from 'react-use';
import { printTable } from '../../../../../utils/tableExportUtils';
export default function ReadPressRelease() {
  const defaultImgSrc = '/img/defaultImg.jpg';
  const isActive = useSelector((state) => state.toggle.isActive);
  const [infographicID, setInfographicID] = useState(0);
  const [title, setTitle] = useState('');
  const [titleEn, setTitleEn] = useState('');
  // const [content, setContent] = useState('');
  // const [contentEn, setContentEn] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [imageSrc, setImageSrc] = useState(defaultImgSrc);
  const [keywords, setKeywords] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [link, setLink] = useState('');
  const [userID, setUserId] = useState(0);
  const [apiData, setApiData] = useState([]);
  const [gridModalcreate, setGridModalcreate] = useState(false);
  const [gridModalupdate, setGridModalupdate] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [next, setNext] = useState(1);
  const [searchTitle, setSearchTitle] = useState('');
  const [recordID, setRecordID] = useState(null);
  const [file, setFile] = useState(null);
  const [doc, setDoc] = useState('');
  const [base64URL, setBase64URL] = useState('');
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [renderLink, setRenderLink] = useState('');

  const fileInputRef = useRef(null);
  const toggleShowUpdate = () => setGridModalupdate(!gridModalupdate);

  const toggleShowCreate = (e) => {
    setGridModalcreate(!gridModalcreate);
    setTitleEn('');
    setTitle('');
    // setContent('');
    // setContentEn('');
    setPublicationDate('');
    setKeywords('');
    setLink('');
    fileInputRef.current.value = '';
  };
  const toggleShowOpen = () => setGridModalOpen(!gridModalOpen);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const epUser = localStorage.getItem('apid');
  const token = localStorage.getItem('token');
  const todayDate = new Date();
  const { pathname } = useLocation();

  const isLogin = () => {
    if (!token && epUser === '') {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const bodyGet = {
    epUserID: parseInt(epUser),
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const getData = async () => {
    setIsLoad(true);
    await postAsync(
      'CMSInfographic/GetInfographicFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      bodyGet,
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setNext(pageOptions.pageNo);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const getDataByID = async (id) => {
    await getAsync('CMSInfographic/GetByIdCMSInfographic', {
      id: id,
    })
      .then((response) => {
        setInfographicID(response?.data[0].infographicID);
        setTitle(response?.data[0].title);
        setTitleEn(response?.data[0].titleEn);
        const date = response?.data[0].publicationDate.split('/');
        const formateddate = `${date[2]}-${date[1]}-${date[0]}`;
        setPublicationDate(formateddate);
        setKeywords(response?.data[0].keywords);
        setLink(response?.data[0].link);
        // setContent(response?.data[0].content);
        // setContentEn(response?.data[0].contentEn);
        setUserId(response?.data[0].userID);
        setDoc(response?.data[0]?.doc);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const SearchFilter = {
    // epUserID: epUser,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    cmsTitle: searchTitle,
  };

  const SearchRecord = async () => {
    try {
      setIsLoad(true);
      setDatanotfound(false);
      const response = await postAsync(
        `CMSInfographic/GetInfographicFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const bodyCreate = {
    InfographicID: 0,
    title,
    // content,
    titleEn,
    // contentEn,
    publicationDate,
    keywords,
    link,
    userID: parseInt(epUser),
    file,
    // base64URL
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (
      // content == '' ||
      keywords == '' ||
      link == '' ||
      publicationDate == '' ||
      // contentEn == '' ||
      titleEn == '' ||
      title == '' ||
      file == null
    ) {
      toast.error(t(`please fill all fields`));
    } else {
      await postAsync(
        'CMSInfographic/CreateCMSInfographic',
        bodyCreate,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        },
        'multipart/form-data',
      )
        .then((response) => {
          setApiData(response?.data);
          toast.success(`${t('Created Successfully')}`);
          getData();
          setTitleEn('');
          setTitle('');
          // setContent('');
          // setContentEn('');
          setPublicationDate('');
          setKeywords('');
          setLink('');
          setFile('');
          setBase64URL('');
          toggleShowCreate(e);
          setDatanotfound(false);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const updateRecordById = (e, id) => {
    e.preventDefault();
    toggleShowUpdate();
    getDataByID(id);
    setRecordID(id);
  };

  const onUpdate = async (id) => {
   
    // e.preventDefault();
    if (
      // content == '' ||
      (keywords == '' ||
        link == '' ||
        publicationDate == '' ||
        // contentEn == '' ||
        titleEn == '' ||
        title == ''
      // file == null
    )
    ) {
      toast.error(t(`please fill all fields`));
    } else {
      await putAsync(
        'CMSInfographic/UpdateCMSInfographic',
        bodyUpdate,
        {
          id: id,
        },
        'multipart/form-data',
      )
        .then((response) => {
          setApiData(response?.data);
          getData();
          toast.success(`${t('Updated Successfully')}`);
          navigate('/readInfographic');
          setGridModalupdate(false);
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const showPreview = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setImageSrc(x.target.result);

        const base64 = x.target.result.split(',').splice(1, 1)[0];
        setDoc(base64);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setImageSrc(defaultImgSrc);
    }
  };
  const handleDownload = async (e, id, fileName) => {
    e.preventDefault();
    try {
      const response = await getAsync('CMSInfographic/GetByIdCMSInfographic', { id: id });
      const link = document.createElement('a');
      link.href = `data:image/png;base64,${response?.data[0]?.doc}`;
      link.download = fileName || 'image.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(t('Error downloading file Please try Again'), error);
    }
  };

  const openModal = async (e, photoGalleryID) => {
    e.preventDefault();
    // const selectedData = apiData?.find((data) => data?.photoGalleryID === photoGalleryID)?.doc;
    try {
      const response = await getAsync('CMSInfographic/GetByIdCMSInfographic', { id: photoGalleryID });
      setRenderLink(response?.data[0]?.doc);
    } catch (error) {
      console.log(error);
    }
    setGridModalOpen(true);
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row className="font-sm" key={index}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{isActive ? data?.title || '' : data?.titleEn || ''}</Table.Cell>
        {/* <Table.Cell>{ isActive ? data?.content || '' : data?.contentEn || '' }</Table.Cell> */}
        <Table.Cell>{data.publicationDate}</Table.Cell>
        <Table.Cell>{data?.link ? data?.link : 'N/A'}</Table.Cell>
        <Table.Cell>{data?.keywords ? data?.keywords : 'N/A'}</Table.Cell>

        <Table.Cell>
          {/* Modal Create */}
          <>
            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => openModal(e, data?.infographicID)}
              style={{
                margin: '5px',
              }}
            >
              <VisibilityOutlinedIcon />
            </button>
          </>

          {/* end */}

          <button
            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
            onClick={(e) => handleDownload(e, data?.infographicID, data?.fileName)}
            style={{ margin: '5px' }}
          >
            <FileDownloadOutlinedIcon />
          </button>
        </Table.Cell>

        <Table.Cell>
          <>
            <button
              className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
              type="button"
              onClick={(e) => {
                updateRecordById(e, data?.infographicID);
                setGridModalupdate(true);
              }}
            >
              {t('Update')}
            </button>
          </>
          {/* end */}
        </Table.Cell>
        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
            onClick={() => onDelete(data.infographicID)}
          >
            {t('delete')}
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });

  const bodyUpdate = {
    title,
    // content,
    titleEn,
    // contentEn,
    publicationDate,
    keywords,
    link,
    userID: parseInt(epUser),
    file,
  };

  const onDelete = async (id) => {
    await deleteAsync('CMSInfographic/DeleteCMSInfographic/', {
      id: id,
    })
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(t('Deleted Successfully'));
          getData();
          setApiData(response?.data);
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const validate = () => {
    let result = true;
    if (title === '' || title === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_title')}`);
    }
    if (publicationDate === '' || publicationDate === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_publicationDate')}`);
    }
    if (keywords === '' || keywords === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_keywords')}`);
    }
    if (link === '' || link === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_link')}`);
    }
    if (userID === '' || userID === null) {
      result = false;
      toast.warning(`${t('msg_pleaseEnter')}``${t('cms_userID')}`);
    }
    return result;
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;

    await postAsync('CMSInfographic/GetInfographicFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      Title: isActive ? item.title : item.titleEn,
      // 'Content': isActive ? item.content : item.contentEn,
      'Publication Date': item.publicationDate,
      Link: item.link,
      Keywords: item.keywords,
    }));

    downloadCSV(filteredData, 'Read Info Graphic');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('navItem_infographic')} ${t('list')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">
  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('cms_title')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_publicationDate`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_link`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_keywords`)}</th>
  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.title || '' : data?.titleEn || ''}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.publicationDate}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd; text-wrap: wrap;">${data?.link ? data?.link : 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.keywords || 'N/A'}</td>
  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }

  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('cms_title'),
      accessor: (row) => isActive ? row?.title : row?.titleEn
    },   {
      header: t('cms_publicationDate'),
      accessor: (row) => isActive ? row?.publicationDate  || 'N/A' : row?.publicationDate  || 'N/A'
    },   {
      header: t('cms_link'),
      accessor: (row) => isActive ? row?.link  || 'N/A' : row?.link || 'N/A'
    },
    {
      header: t('cms_keywords'),
      accessor: (row) => row?.keywords || 'N/A'
    }

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('navItem_infographic')} ${t('list')}`,
    columns: columns,
    onBeforePrint: () => {
      // console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      // console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    const imgSize = selectedFile.size;
    const extension = selectedFile?.name.split('.')[1];
    if ((extension == 'jpg' || extension == 'png' || extension == 'PNG' || extension == 'jpeg') && imgSize <= 2097152) {
      getBase64(selectedFile)
        .then((result) => {
          selectedFile['base64'] = result;
          setBase64URL(result);
          setDoc(result.split(',')[1]);
          setFile(selectedFile);
          toast.success(t('File uploaded successfully.'));
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        setBase64URL('');
        setDoc('');
        setFile('');
      }
      toast.error(t('Only PNG, JPG, and JPEG files are allowed. Maximum file size: 2MB.'));
    }
  };

  return (
    <div className="">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <div className="container-fluid pb-5">
            {/* <Link style={{float : 'right', width: '6%'}} to={'/createInfographic'}>
                <Button  className="btn btn-success">Create</Button>
           </Link> */}

            {/* <div className=" row justify-center">
              <div className="col-lg-11 text-center">
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen">
                  {t('cms_infographic')} {t('list')}
                </h3>
              </div>
            </div> */}

            <div className="row text-center">
              <div className="col-lg-11 flex justify-end my-4">
                <button
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center
"
                  onClick={toggleShowCreate}
                >
                  {t('create')}
                </button>
              </div>
            </div>

            <div className="row justify-center flex-row">
              <SearchFilters
                handleSearch={SearchRecord}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'cms_infographic'}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={false}
              />
            </div>

            {/* Modal Create */}
            <>
              <MDBModal tabIndex="-1" show={gridModalcreate} setShow={setGridModalcreate}>
                <MDBModalDialog className="flex justify-center items-center">
                  <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                    <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                      <MDBModalHeader className="flex justify-center items-center">
                        <MDBModalTitle className="text-customgreen font-semibold">
                          {t('create')} {t('cms_infographic')}
                        </MDBModalTitle>
                        {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div className="container-fluid bd-example-row">
                          <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-6 col-example">
                              <label className="mx-auto text-customgreen">{t('cms_title')}: </label>
                              <input
                                maxLength={1000}
                                name="title"
                                value={title}
                                className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                type="text"
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder={t('cms_title')}
                              />
                            </div>

                            <div className="col-md-6 col-example">
                              <label className="mx-auto text-customgreen">{t('Title En')}: </label>
                              <input
                                maxLength={1000}
                                name="titleEn"
                                value={titleEn}
                                className="  border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                type="text"
                                onChange={(e) => setTitleEn(e.target.value)}
                                placeholder={t('Title')}
                              />
                            </div>
                            {/* <div className="col-md-6 col-example ">
                              <label className="mx-auto text-customgreen">{ t('cms_content') }: </label>
                              <textarea
                                name="content"
                                value={ content }
                                className=" border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                                onChange={ (e) => setContent(e.target.value) }
                                placeholder={ t('Content') }
                              />
                            </div> */}
                            {/* <div className="col-md-6 col-example">
                              <label className="mx-auto text-customgreen">{ t('Content En') }: </label>
                              <textarea
                                name="contentEn"
                                value={ contentEn }
                                className=" border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen "
                                onChange={ (e) => setContentEn(e.target.value) }
                                placeholder={ t('Content') }
                              />
                            </div> */}
                            <div className="col-md-6  col-example">
                              <label className="mx-auto text-customgreen">{t('cms_keywords')} : </label>
                              <input
                                name="keywords"
                                value={keywords}
                                onChange={(e) => setKeywords(e.target.value)}
                                className=" border w-full p-2 border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen focus:ring-2 "
                                placeholder={t('cms_keywords')}
                              />
                            </div>
                            <div className="col-md-6  col-example">
                              <label className="mx-auto text-customgreen">{t('cms_link')} : </label>
                              <input
                                name="link"
                                value={link}
                                className="border w-full border-gray-300 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen"
                                type="text"
                                onChange={(e) => setLink(e.target.value)}
                                placeholder={t('cms_link')}
                              />
                            </div>
                            <div className="col-md-6 col-example">
                              <div className="flex flex-col">
                                <DatePickerLayout
                                  label={'cms_publicationDate'}
                                  selectedDate={publicationDate}
                                  keyValue={'to'}
                                  dateTo={publicationDate}
                                  setDateTo={setPublicationDate}
                                  maxDate={todayDate}
                                />
                              </div>
                            </div>
                            <div className="col-md-6 col-example">
                              <label className="mx-auto text-customgreen">{t('cms_image')}</label>
                              <input
                                ref={fileInputRef}
                                onChange={handleFileInputChange}
                                type="file"
                                className="  border w-full border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                              />

                              {/* <img style={{ height: '120px', width: '150px' }} src={values.imageSrc} className="card-img-top" /> */}
                            </div>
                          </div>
                          <div className="flex justify-center mt-2  ">
                            <div className="" />
                            <img
                              style={{
                                height: '120px',
                                width: '150px',
                              }}
                              src={base64URL ? `${base64URL}` : imageSrc}
                              // onChange={(e) => setLink(e.target.files[0])}
                              className="card-img-top"
                              alt=""
                            />
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter className="flex justify-center">
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                          onClick={(e) => {
                            onSubmit(e);
                          }}
                        >
                          {t('create')}
                        </button>
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={toggleShowCreate}
                        >
                          {t('close')}
                        </button>
                      </MDBModalFooter>
                    </Form>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>
            {/* Update Modal */}
            <InfograpicModal
              updateRecordById={updateRecordById}
              t={t}
              gridModalupdate={gridModalupdate}
              setGridModalupdate={setGridModalupdate}
              recordID={recordID}
              title={title}
              setTitle={setTitle}
              // content={ content }
              // setContent={ setContent }
              titleEn={titleEn}
              setTitleEn={setTitleEn}
              // contentEn={ contentEn }
              // setContentEn={ setContentEn }
              publicationDate={publicationDate}
              setPublicationDate={setPublicationDate}
              keywords={keywords}
              setKeywords={setKeywords}
              link={link}
              setLink={setLink}
              onUpdate={onUpdate}
              doc={doc}
              setDoc={setDoc}
              imageSrc={imageSrc}
              showPreview={showPreview}
              onChange={handleFileInputChange}
              fileInputRef={fileInputRef}
            />

            <ImageViewModal
              showModal={gridModalOpen}
              setShowModal={setGridModalOpen}
              closeModal={toggleShowOpen}
              title={''}
              renderLink={''}
              imgDoc={renderLink}
            />
            <div className="flex flex-col pt-9 ">
              <div className="row justify-center">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="col-lg-11 text-center">
                    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                      <Table className="text-sm tableData text-center  rtl:text-right ">
                        <Table.Header className="font-bold text-white whitespace-nowrap bg-customgreen uppercase ">
                          <Table.Row>
                            <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_title')}</Table.HeaderCell>
                            {/* <Table.HeaderCell className="text-white">{ t('cms_content') }</Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white">{t('cms_publicationDate')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_link')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('cms_keywords')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white"></Table.HeaderCell>

                            {/* <Table.HeaderCell>{t('cms_userID')}</Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                            <Table.HeaderCell>{t('')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>{displayRecords}</Table.Body>
                      </Table>
                      {datanotfound && <DataNotFound />}
                    </div>

                    {pageCount > 0 && (
                      <div className="flex flex-row px-12 justify-between">
                        <Menu pagination>
                          <Menu.Item>
                            <ReactPaginate
                              previousLabel={t('Previous')}
                              nextLabel={t('Next')}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={'paginationButtons'}
                              previousLinkClassName={'previousButton'}
                              nextLinkClassName={'nextButton'}
                              disabledClassName={'paginationDisabled'}
                              activeClassName={'paginationActive'}
                            />
                          </Menu.Item>
                        </Menu>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
